import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    IconButton,
    Typography
} from "@mui/material";

import { CopyAllOutlined } from "@mui/icons-material";
import CounterAdoptingSerialNumberGeneratorFactory from "../../../lib/serialNumber/CounterAdoptingSerialNumberGeneratorFactory";
import { ResourceType } from "../../../API";
import SerialNumberGenerator from "../../../lib/serialNumber/SerialNumberGenerator";
import { usePageDefaultStyle } from "../../../assets/style/usePageDefaultStyle";
import { useSnackbar } from "notistack";
import { useState } from "react";

const serialNumberGenerator: SerialNumberGenerator = CounterAdoptingSerialNumberGeneratorFactory.getInstance();

export const GeneratePNumberPage = () => {
    const { pageDefaultStyle } = usePageDefaultStyle();
    const [pNumber, setPNumber] = useState<number | null>(null);
    const [isGenerating, setIsGenerating] = useState<boolean>(false);
    const snackbar = useSnackbar();

    const generatePNumber = async () => {
        try {
            setIsGenerating(true);
            const pNumber = await serialNumberGenerator.generate(
                ResourceType.PROPOSAL.toString(),
                ResourceType.PROPOSAL
            );
            setPNumber(pNumber);
        } catch (e) {
            console.error(e);
        } finally {
            setIsGenerating(false);
        }
    };

    return (
        <Box sx={pageDefaultStyle}>
            <Card>
                <CardContent sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 2 }}>
                    <Typography variant="h4" color="black">
                        PNumber Generator
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={generatePNumber}
                        disabled={isGenerating}
                        sx={{ px: 4 }}
                    >
                        {isGenerating ? "Generating..." : "Generate PNumber"}
                    </Button>
                    {pNumber && (
                        <Box display="flex" flexDirection="column" gap={0.5}>
                            <Typography color="gray" variant="body2" sx={{ px: 1 }}>
                                Generated PNumber:
                            </Typography>
                            <Box display="flex" gap={0.5}>
                                <Chip label={pNumber} sx={{ fontWeight: 500, flex: 1 }} />
                                <IconButton
                                    size="small"
                                    onClick={async () => {
                                        try {
                                            await navigator.clipboard.writeText(pNumber.toString());
                                            snackbar.enqueueSnackbar("Copied to clipboard", { variant: "success", autoHideDuration: 1000 });
                                        } catch (e) {
                                            console.error(e);
                                            snackbar.enqueueSnackbar("Failed to copy to clipboard", { variant: "error", autoHideDuration: 1000 });
                                        }
                                    }}
                                >
                                    <CopyAllOutlined />
                                </IconButton>
                            </Box>
                        </Box>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};